import React from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import IconButton from "@material-ui/core/IconButton";
import ResponsiveComponent from "@components/form/ResponsiveComponent";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from '@material-ui/core/styles';
import {walk} from "~/utils/object";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
    root: {
        border: '2px solid #f5f5f5',
        borderBottom: '1px solid #f5f5f5',
        width: 'calc(100% - 4px)'
    },
    rootError: {
        border: '2px solid #f44336',
    },
    errorText: {
        color: '#f44336',
        marginTop: 10
    },
    header: {
        backgroundColor: '#f5f5f5',
        borderColor: '#f5f5f5',
    },
    cell: {
        borderColor: '#f5f5f5',
        fontWeight: 'normal',
    },
    mobileWrapper: {
        '& .MuiCard-root + .MuiCard-root': {
            marginTop: '20px',
        },
    },
    mobileRow: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
            border: 'none',
        },
    },
    mobileCell: {
        padding: '15px 20px',
        width: '100%',
        '& .MuiTypography-root + .MuiTypography-root': {
            marginTop: '15px',
        },
        '&:last-child': {
            paddingBottom: '30px',
        },
    },
    mobileActions: {
        backgroundColor: '#f5f5f5',
        paddingRight: '3px',
    },
    noDataCell: {
        color: '#9e9e9e',
        borderColor: '#f5f5f5',

        [theme.breakpoints.down('sm')]: {
            minHeight: '100px',
        },
    },
    mobileRowDescription: {
        margin: '10px 0px 20px'
    },
}));

const actionsRender = (actions, row, index) => {
    return actions.map((action, key) => <IconButton
        key={`action${key}`}
        color={'primary'}
        onClick={(e) => action.onClick(e, row, index)}
    >
        {action.icon(row, index)}
    </IconButton>)
}

const mobileActionsRender = (actions, row, index) => {
    return actions.map((action, key) => <React.Fragment
        key={`action${key}`}
    >
        {action.icon(row, index)}
    </React.Fragment>)
}

export const MaterialTableComponent = ({
                                           columns,
                                           data,
                                           actions,
                                           errors = null,
                                           name = null,
                                           mobileActions = null,
                                           mobileTableVersion = false,
                                           addPanel = null,
                                           customLastRow = null,
                                           dataMobileDescription = null,
                                       }) => {
    const classes = useStyles();

    return (
        <ResponsiveComponent
            xs={mobileTableVersion
                ? <TableContainer className={classes.root}>
                    <Table>
                        <TableBody>
                            {data.length > 0
                                ? <>
                                    {data.map((row, rowIndex) => (<React.Fragment key={`row-${rowIndex}`}>
                                        {columns.filter(column => !column.hidden && !column.showInDesktop).map((column, index) => <TableRow key={`column-${index}`} {...column.mobileCellProps}>
                                            {!column.hideMobileTitle ? <TableCell variant={'head'}>{column.title}</TableCell> : null}
                                            <TableCell>{ column.mobileRender
                                                ? column.mobileRender(row, rowIndex)
                                                : column.render
                                                    ? column.render(row, rowIndex)
                                                    : <Typography>{walk(row, column.field, '')}</Typography>
                                            }</TableCell>
                                        </TableRow>)}
                                    </React.Fragment>))}
                                    { addPanel && addPanel.isOpen && <>
                                        {addPanel.items.map((item, index) => <TableRow key={`addPanelItem-${index}`}>
                                            <TableCell colSpan={2}>
                                                {item}
                                            </TableCell>
                                        </TableRow>)}
                                    </>}
                                </>
                                : <>
                                    <TableRow className={classes.header} style={{minHeight: '40px'}}>
                                        <TableCell className={classes.noDataCell}></TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className={classes.noDataCell} align={'center'}>
                                            Данных нет
                                        </TableCell>
                                    </TableRow>
                                </>
                            }
                            {customLastRow && <>{customLastRow(classes)}</>}
                        </TableBody>
                    </Table>
                </TableContainer>
                : <>
                    <div
                        className={clsx(classes.mobileWrapper, {
                            [classes.rootError]: !!errors?.[name],
                        })}
                    >
                        {data.length > 0
                            ? <>
                                {data.map((row, rowIndex) => <>
                                    <Card key={`mobileCard-${rowIndex}`} variant="outlined">
                                        <CardContent className={classes.mobileRow}>
                                            {actions.length > 0 && <Grid container justify={'flex-end'} className={classes.mobileActions}>
                                                {actionsRender(actions, row, rowIndex)}
                                            </Grid>}
                                            {mobileActions && mobileActions.length > 0 && <Grid container justify={'flex-end'} className={classes.mobileActions}>
                                                {mobileActionsRender(mobileActions, row, rowIndex)}
                                            </Grid>}
                                            <Grid container direction={'column'}>
                                                {columns.map((column, index) => <Grid item key={`column-${index}`} className={classes.mobileCell} {...column.mobileCellProps}>
                                                    { !column.hideMobileTitle && <Typography>{column.title}</Typography> }
                                                    { column.mobileRender
                                                        ? column.mobileRender(row, rowIndex)
                                                        : column.render
                                                            ? column.render(row, rowIndex)
                                                            : <Typography>{walk(row, column.field, '')}</Typography>
                                                    }
                                                </Grid>)}
                                            </Grid>
                                        </CardContent>
                                    </Card>

                                    {dataMobileDescription && dataMobileDescription[rowIndex]
                                        ? <div className={classes.mobileRowDescription}>{dataMobileDescription[rowIndex]}</div>
                                        : null
                                    }
                                </>)}
                            </>
                            :<Card variant="outlined">
                                <CardContent className={classes.mobileRow}>
                                    <div container justify={'flex-end'} className={classes.mobileActions} style={{height: '54px'}}></div>
                                    <Grid container alignItems={'center'} justify={'center'} className={classes.noDataCell}>
                                        <Grid item>Данных нет</Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        }
                        {customLastRow && <>{customLastRow(classes)}</>}
                    </div>
                    {!!errors?.[name] ? <Typography variant="caption" className={classes.errorText}>{errors[name].join(' ')}</Typography> : null}
                </>
            }
            md={<>
                <TableContainer
                    className={clsx(classes.root, {
                        [classes.rootError]: !!errors?.[name],
                    })}
                >
                    <Table>
                        <TableHead>
                            <TableRow className={classes.header}>
                                {columns.filter(column => !column.hidden && !column.showInMobile).map((column, index) => <TableCell
                                    className={classes.cell}
                                    key={`head-${index}`}
                                    align={column.align ?? "left"}
                                    {...column.headerProps}
                                >
                                    {column.headerRender ? column.headerRender(column) : column.title}
                                </TableCell>)}
                                {actions.length > 0 && <TableCell className={classes.cell} align="left"></TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.length > 0
                                ? <>
                                    {data.map((row, rowIndex) => <TableRow key={`dataRow-${rowIndex}`}>
                                        {columns.filter(column => !column.hidden && !column.showInMobile).map((column, index) =>
                                            <TableCell
                                                className={classes.cell}
                                                key={`row-${column.field}-${rowIndex}`}
                                                align={column.align ?? "left"}
                                                {...column.cellProps}
                                            >
                                                { column.render ? column.render(row, rowIndex) : walk(row, column.field, '') }
                                            </TableCell>
                                        )}
                                        {actions.length > 0 && <TableCell className={classes.cell} align={'right'} style={{minWidth: 48 * actions.length}}>
                                            {actionsRender(actions, row, rowIndex)}
                                        </TableCell>}
                                    </TableRow>)}
                                </>
                                : <TableRow>
                                    <TableCell className={classes.noDataCell} align={'center'} colSpan={columns.length + (actions.length > 0)}>
                                        Данных нет
                                    </TableCell>
                                </TableRow>
                            }
                            {customLastRow && <>{customLastRow(classes)}</>}
                            { addPanel && addPanel.isOpen && <TableRow>
                                {addPanel.items.map((item, index) => <TableCell key={`addPanelItem-${index}`}>
                                    {item}
                                </TableCell>)}
                            </TableRow>}
                        </TableBody>
                    </Table>
                </TableContainer>
                {!!errors?.[name] ? <Typography variant="caption" className={classes.errorText}>{errors[name].join(' ')}</Typography> : null}
            </>}
        />
    )
};
